import React, { useState, useEffect } from 'react';
import { SpotlightCard } from '@atlaskit/onboarding';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import { Link } from 'react-router-dom';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';

import { useLocalStorage } from '@/controllers';
import { flexCenter, popup, spaceGapTiny } from '@/styles';

const INFO_STATUS_ACTIONED: string = 'actioned_global-info-real-time-charting';
const INFO_TEXT = `Tome now supports real-time charts. Users will now see the current day (UTC) SLO performance data in addition to the past 28 days SLO performance.`;
const LINK_URL = 'https://hello.atlassian.net/wiki/x/otUmMQE';

const backgroundColor = token('color.background.accent.purple.bolder');
const textColor = token('color.text.inverse');
/*
// switch to this when we have a warning
const warningStyles = css`
  & > div {
    background: ${token('color.background.warning.bold')};
    color: ${token('color.text')};
  }
`;
*/
const infoStyles = css`
  & > div {
    background: ${backgroundColor};
    color: ${textColor};
  }
`;

const iconStyles = css`
  position: relative;
  top: 4px;
  left: -2px;
  marginright: 4px;
  color: ${textColor};
`;

const textStyles = css`
  color: ${textColor};
`;

const GlobalInfo: React.FC = () => {
  const [infoVisible, setInfoVisible] = useState(false);
  const [infoStatus, setInfoStatus] = useLocalStorage('tome-global-info', '');

  const handleRemove = () => {
    setInfoStatus(INFO_STATUS_ACTIONED);
    setInfoVisible(false);
  };

  useEffect(() => {
    if (infoStatus !== INFO_STATUS_ACTIONED) setInfoVisible(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!infoVisible) return <></>;

  return (
    <div css={[popup, infoStyles]}>
      <SpotlightCard
        isFlat
        actions={[
          {
            text: 'Dismiss',
            onClick: handleRemove,
            style: { color: textColor },
          },
          {
            text: (
              <Link target="_blank" to={LINK_URL}>
                <span css={[flexCenter, spaceGapTiny]}>
                  <EditorPanelIcon
                    label="info"
                    secondaryColor={backgroundColor}
                    primaryColor="inherit"
                  />
                  <span>Learn More</span>
                </span>
              </Link>
            ),
            onClick: handleRemove,
          },
        ]}
      >
        <div>
          <span css={iconStyles}>
            <FeedbackIcon label="News" secondaryColor={backgroundColor} primaryColor="inherit" />
          </span>
          <span css={textStyles}>{INFO_TEXT}</span>
        </div>
      </SpotlightCard>
    </div>
  );
};

export default GlobalInfo;
